import { createReducer, on } from '@ngrx/store';
import * as PlantListCompanyByUserGuidActions from './plant-list-company-by-userguid.actions';
import { PlantListCompanyByUserGuidState } from './plant-list-company-by-userguid.models';

export const initialState: PlantListCompanyByUserGuidState = {
  plants: {},
  loading: false,
  error: null,
};

export const plantListCompanyByUserGuidReducer = createReducer(
  initialState,
  on(PlantListCompanyByUserGuidActions.loadPlantListCompanyByUserGuid, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PlantListCompanyByUserGuidActions.loadPlantListCompanyByUserGuidSuccess, (state, { userGuid, plants }) => ({
    ...state,
    loading: false,
    error: null,
    plants: { ...state.plants, [userGuid]: plants },
  })),
  on(PlantListCompanyByUserGuidActions.loadPlantListCompanyByUserGuidFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(PlantListCompanyByUserGuidActions.resetPlantListCompanyByUserGuid, () => initialState),
);
